
const def = require<any>("./default.json");

const en_US = require<any>("./en-us.json");
const fr_CA = require<any>("./fr-ca.json");
const es_ES = require<any>("./es-es.json");
const es_MX = require<any>("./es-mx.json");

export default {
    default: def,
    ['en-US']: en_US,
    ['fr-CA']: fr_CA,
    ['es-ES']: es_ES,
    ['es-MX']: es_MX
};


// WEBPACK FOOTER //
// ./src/i18n/ticketing/index.ts